// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-ui {
  color: var(--undp-jtf-btn-dark-color);
}`, "",{"version":3,"sources":["webpack://./apps/hybrid-app/src/app/features/shared/post-search/post-search.component.scss"],"names":[],"mappings":"AAAA;EACE,qCAAA;AACF","sourcesContent":[".custom-ui {\n  color:  var(--undp-jtf-btn-dark-color);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
